import React, { useEffect, useState } from 'react';
import {
  CountBoxDiv,
  CountDownContainer,
} from '../../../StoreHomePage/TimerWithCTA/styled';

const LightningTimer = (props) => {
  const { endTime } = props;
  const endDate = new Date(endTime);

  const calculateTimeLeft = () => {
    const difference = new Date(endDate) - new Date();
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        daysInString: Math.floor(difference / (1000 * 60 * 60 * 24)).toString(),
        hoursInString: Math.floor(
          (difference / (1000 * 60 * 60)) % 24,
        ).toString(),
        minuteInString: Math.floor((difference / 1000 / 60) % 60).toString(),
        secondInString: Math.floor((difference / 1000) % 60).toString(),
      };
      for (const key in timeLeft) {
        if (timeLeft[key].length === 1) timeLeft[key] = '0' + timeLeft[key];
      }
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  });
  const { daysInString, hoursInString, minuteInString, secondInString } =
    timeLeft;

  return (
    <CountDownContainer>
      <p style={{ marginRight: '4px' }}>{'Ends in:'}</p>
      {daysInString > 0 ? (
        <>
          <CountBoxDiv>
            <p>{daysInString?.[1]}</p>
          </CountBoxDiv>
          <span>{'days'}</span>
        </>
      ) : null}

      <CountBoxDiv>
        <p>
          {hoursInString?.[0] != '0' ? hoursInString?.[0] : ''}

          {hoursInString?.[1]}
        </p>
      </CountBoxDiv>
      <span>{'hrs'}</span>
    </CountDownContainer>
  );
};

export default LightningTimer;
